import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type CourtCasePaymentEventsQueryVariables = Types.Exact<{
  courtCaseUuid: Types.Scalars['String']
  filters: Types.CourtCasePaymentEventsListFilterInput
  sorts?: Types.InputMaybe<Types.CourtCasePaymentEventsListSortInput>
  pagination?: Types.InputMaybe<Types.PaginationInput>
}>

export type CourtCasePaymentEventsQuery = {
  __typename?: 'Query'
  courtCases: {
    __typename?: 'CourtCasesCollection'
    items: Array<{
      __typename?: 'CourtCase'
      uuid: string
      paymentEvents: {
        __typename?: 'CourtCasePaymentEventsCollection'
        items: Array<{
          __typename?: 'CourtCasePaymentEvent'
          uuid: string
          type: Types.CourtCasePaymentEventType
          updatedAt: any
          payload?: any | null
          createdAt: any
          initiatorRole: Types.UserRole
        }>
      }
    }>
  }
}

export const CourtCasePaymentEventsDocument = gql`
  query CourtCasePaymentEvents(
    $courtCaseUuid: String!
    $filters: CourtCasePaymentEventsListFilterInput!
    $sorts: CourtCasePaymentEventsListSortInput
    $pagination: PaginationInput
  ) {
    courtCases(filters: { uuid: { equals: $courtCaseUuid } }) {
      items {
        uuid
        paymentEvents(filters: $filters, sorts: $sorts, pagination: $pagination) {
          items {
            uuid
            type
            updatedAt
            payload
            createdAt
            initiatorRole
          }
        }
      }
    }
  }
`
export function useCourtCasePaymentEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CourtCasePaymentEventsQuery,
    CourtCasePaymentEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CourtCasePaymentEventsQuery,
    CourtCasePaymentEventsQueryVariables
  >(CourtCasePaymentEventsDocument, options)
}
export function useCourtCasePaymentEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CourtCasePaymentEventsQuery,
    CourtCasePaymentEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CourtCasePaymentEventsQuery,
    CourtCasePaymentEventsQueryVariables
  >(CourtCasePaymentEventsDocument, options)
}
export type CourtCasePaymentEventsQueryHookResult = ReturnType<
  typeof useCourtCasePaymentEventsQuery
>
export type CourtCasePaymentEventsLazyQueryHookResult = ReturnType<
  typeof useCourtCasePaymentEventsLazyQuery
>
export type CourtCasePaymentEventsQueryResult = ApolloReactCommon.QueryResult<
  CourtCasePaymentEventsQuery,
  CourtCasePaymentEventsQueryVariables
>
export function refetchCourtCasePaymentEventsQuery(
  variables?: CourtCasePaymentEventsQueryVariables
) {
  return { query: CourtCasePaymentEventsDocument, variables: variables }
}
